import React from 'react';
import clsx from 'clsx';

export interface TableBodyProps
  extends React.DetailedHTMLProps<
    React.HTMLAttributes<HTMLTableSectionElement>,
    HTMLTableSectionElement
  > {
  className?: string;
}
export const TableBody: React.FC<TableBodyProps> = ({
  children,
  className,
  ...props
}) => {
  return (
    <tbody className={clsx('hse-Table__tbody', className)} {...props}>
      {children}
    </tbody>
  );
};
